import { TERM_TOKENS } from "@/data/glossary";
import TermTip from "./TermTip";

// Compile a single regex that splits a string on any acronym token.
// Longest-first ordering already applied in TERM_TOKENS.
const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const TOKEN_REGEX = new RegExp(`(${TERM_TOKENS.map(escape).join("|")})`, "g");
const TOKEN_SET = new Set(TERM_TOKENS);

/**
 * Renders a plain string, auto-wrapping any glossary acronym in a <TermTip>.
 * Case-sensitive: only all-caps acronyms are matched so mixed-case English
 * words are left untouched.
 */
export const TermRichText = ({ text }) => {
  if (!text) return null;
  const parts = text.split(TOKEN_REGEX);
  return (
    <>
      {parts.map((part, i) =>
        TOKEN_SET.has(part) ? <TermTip key={i} term={part} /> : <span key={i}>{part}</span>
      )}
    </>
  );
};

export default TermRichText;
